import React from 'react';
import styled  from '../styled'
const { mlr } = styled;

export const HighMedLowColor = () => (
    <div className='widgitsView'>
    <span><svg height="8" width="8"> <circle cx="4" cy="4" r="4" fill='red' />
    </svg><span style={mlr}>High</span></span>

    {/* <span><svg height="8" width="8"> <circle cx="4" cy="4" r="4" fill='orange' />
    </svg><span style={mlr}>Med</span></span> */}
    
    <span><svg height="8" width="8"> <circle cx="4" cy="4" r="4" fill='green' />
    </svg><span style={mlr}>Low</span></span>
    </div>
)